module.exports = __webpack_public_path__ + "img/activation-code-en.78dae008.svg";